import "../../../../utils/Css/employeelist.css";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useState, useEffect } from "react";
import "toastr/build/toastr.min.css";
import { getHistoriqueFicheDePaie } from "../../../../services/RHService/EmployeeService";

import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import withLoader from "../../../../components/layouts/WithLoader";
import { generateFicheDePaie } from "../../../../services/RHService/PaiementService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

const HistoriqueFicheDePaie = ({ startLoading, stopLoading }) => {
  const [fiechesDePaie, setFiechesDePaie] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  useEffect(() => {
    startLoading();
    getHistoriqueFicheDePaie(localStorage.getItem("idEmployeFiche"))
      .then((response) => {
        setFiechesDePaie(response);
        stopLoading();
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onUploadFileHandler = (idFichedePaie) => {
    startLoading();
    generateFicheDePaie(getCurrentUserId(), idFichedePaie)
      .then((response) => {
        console.log("response", response);

        onShowFileInOtherWizndowHandler(response.data?.path);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      });
  };

  function buttonFileFormatter(cell, row) {
    if (row.path === "any") {
      return (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm text-center"
            onClick={() => onUploadFileHandler(row.idSalary)}
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    } else if (row.urlFile !== "any") {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() => onShowFileInOtherWizndowHandler(row.urlFile)}
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }

  const columns = [
    {
      dataField: "matricule",
      text: "Mat.",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "nb_jrs_de_cong",
      text: "Jours Congé",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "salaireDeBase",
      text: "Salaire de base",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "totprimes",
      text: "Primes",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "salaireBrut",
      text: "Brute",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "cnssContribution",
      text: "CNSS",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    { dataField: "salaireImposable", text: "Salaire Imposable" ,
    align: "center",
    headerAlign: "center",
    headerStyle: () => {
      return { width: "10%" };
    },},
    { dataField: "taxIR", text: "Impôt" ,
    align: "center",
    headerAlign: "center",
    headerStyle: () => {
      return { width: "10%" };
    }, },
    { dataField: "salaryAfterTax", text: "Salaire Après impôt",
    align: "center",
    headerAlign: "center",
    headerStyle: () => {
      return { width: "12%" };
    }, },
    { dataField: "cssContribution", text: "CSS"  ,
    align: "center",
    headerAlign: "center",
    headerStyle: () => {
      return { width: "6%" };
    },},
    { dataField: "salaireApresDeductionCss", text: "Net a payé" ,
    align: "center",
    headerAlign: "center"},
    {
      dataField: "urlFile",
      text: "Fichier",
      formatter: buttonFileFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
  ];
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <ToolkitProvider keyField="id">
        {(props) => (
          <div>
            <section className="content ">
              <div className="container-fluid">
                <div class="card card-dark">
                  <div class="card-header">
                    <h3 class="card-title">Liste des Fiches de paies</h3>
                    <br />
                    <div className="row ml-0">
                      <div></div>
                    </div>
                  </div>
                  <div class="card-body">
                    <BootstrapTable
                      keyField="id"
                      data={fiechesDePaie}
                      columns={columns}
                      pagination={paginationFactory(options)}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      </ToolkitProvider>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default withLoader(HistoriqueFicheDePaie);
